import $ from "jquery";
export default function () {
    if ($('input[data-name=receipt]').length) {
        $('body').on('change', 'input[data-name=receipt]', function () {
            const fileChosen = $(this).parent().find('#file-chosen').get(0);
            // Check filesize greater than 5Mb
            if (this.files[0].size > 5242880) {
                this.value = null;
                fileChosen.innerHTML = `<label class="alert alert-danger">${$('#validation-filesize-message').text()}</label>`;
            } else {
                fileChosen.textContent = this.files[0] ? this.files[0].name : "";
                fileChosen.classList.add('uploaded');
            }
        })
    }

    if ($('.first-product-info-wrap').length) {
        $('body').on('change', '.first-product-info-wrap', function () {
            const $input = $(this).find('.form-check-input');
            const $accordionBody = $(this).parents('.accordion-body');
            const $inputReseller = $accordionBody.find('.input-reseller-wrap .form-control');
            const $inputPurchaseDate = $accordionBody.find('.input-purchase-date-wrap .form-control');
            // const $resellerFieldsWrap = $accordionBody.find('.reseller-fields-wrap');
            const $inputReceiptWrap = $accordionBody.find('.input-receipt-wrap');
            if ($input.prop('checked')) {
                $inputReseller.parent().addClass('disabled');
                $inputPurchaseDate.parent().addClass('disabled');
                $inputReseller.attr('disabled', 'disabled');
                $inputPurchaseDate.attr('disabled', 'disabled');
                $inputReseller.removeAttr('required');
                $inputPurchaseDate.removeAttr('required');
                // $resellerFieldsWrap.addClass('d-none');
                $inputReceiptWrap.addClass('d-none');
            } else {
                $inputReseller.parent().removeClass('disabled');
                $inputPurchaseDate.parent().removeClass('disabled');
                $inputReseller.removeAttr('disabled', 'disabled');
                $inputPurchaseDate.removeAttr('disabled', 'disabled');
                $inputReseller.attr('required', 'required');
                $inputPurchaseDate.attr('required', 'required');
                // $resellerFieldsWrap.removeClass('d-none');
                $inputReceiptWrap.removeClass('d-none');
            }
        });
    }

    if ($('.category__input').length) {
        $('body').on('click', '.category__input', function () {
            const $accordionItem = $(this).parents('.accordion-item');
            // Change image
            const $image = $(this).parent().find('.category__image');
            const $imageSrc = $image.attr('src');
            const $accordionItemTitleImage = $accordionItem.find('.accordion-item-title__image');
            $accordionItemTitleImage.attr('src', $imageSrc);
            // Change name
            const $name = $(this).parent().find('.category__name');
            const $nameText = $name.text();
            const $accordionItemTitleName = $accordionItem.find('.accordion-item-title__label');
            $accordionItemTitleName.text($nameText);
            //reset 12nc e model
            $accordionItem.find('[data-id="inputCode12NC"]').val("").trigger('change');
            $accordionItem.find('[data-id="inputModel"]').val("").trigger('change');
        });
    }

    if ($('input[name="informativa"]').length) {
        $('body').on('click', 'input[name="informativa"], input[name="termini"]', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid');
                $(this).next('.invalid-feedback').remove();
            }
        });
    }
}
